(function () {
  var root = document.querySelector('[data-ivh]');
  if (!root) return;

  /* sticky shadow */
  var sticky = root.querySelector('.ivh-sticky');
  if (sticky) {
    var onScroll = function () { sticky.classList.toggle('is-stuck', window.scrollY > 60); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* mega menus: hover with a short delay, click/keyboard friendly */
  var cats = root.querySelectorAll('[data-ivh-cat].ivh-cat--has');
  var openCat = null, tOpen = null, tClose = null;
  function setOpen(cat) {
    if (openCat && openCat !== cat) {
      openCat.classList.remove('is-open');
      var a0 = openCat.querySelector('.ivh-cat__link'); if (a0) a0.setAttribute('aria-expanded', 'false');
    }
    openCat = cat;
    if (cat) {
      cat.classList.add('is-open');
      var a = cat.querySelector('.ivh-cat__link'); if (a) a.setAttribute('aria-expanded', 'true');
    }
  }
  cats.forEach(function (cat) {
    var link = cat.querySelector('.ivh-cat__link');
    cat.addEventListener('mouseenter', function () {
      clearTimeout(tClose);
      tOpen = setTimeout(function () { setOpen(cat); }, openCat ? 0 : 120);
    });
    cat.addEventListener('mouseleave', function () {
      clearTimeout(tOpen);
      tClose = setTimeout(function () { if (openCat === cat) setOpen(null); }, 180);
    });
    link.addEventListener('click', function (ev) {
      /* touch devices: first tap opens, second tap follows the link */
      if (window.matchMedia('(hover: none)').matches && openCat !== cat) {
        ev.preventDefault(); setOpen(cat);
      }
    });
    link.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowDown' || ev.key === ' ') {
        ev.preventDefault(); setOpen(cat);
        var first = cat.querySelector('.ivh-mega a'); if (first) first.focus();
      }
    });
    cat.addEventListener('focusout', function (ev) {
      if (!cat.contains(ev.relatedTarget) && openCat === cat) setOpen(null);
    });
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && openCat) {
      var a = openCat.querySelector('.ivh-cat__link'); setOpen(null); if (a) a.focus();
    }
  });
  document.addEventListener('click', function (ev) {
    if (openCat && !openCat.contains(ev.target)) setOpen(null);
  });

  /* mobile drawer */
  var drawer = root.querySelector('[data-ivh-drawer]');
  var opener = root.querySelector('[data-ivh-open]');
  function openDrawer() {
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.documentElement.classList.add('ivh-lock');
    opener.setAttribute('aria-expanded', 'true');
    var x = drawer.querySelector('.ivh-drawer__x'); if (x) x.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('ivh-lock');
    opener.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; }, 230);
    opener.focus();
  }
  if (drawer && opener) {
    opener.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-ivh-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeDrawer(); });
  }

  /* predictive search */
  var form = root.querySelector('[data-ivh-search]');
  var input = root.querySelector('[data-ivh-q]');
  var box = root.querySelector('[data-ivh-suggest]');
  if (!form || !input || !box) return;
  var timer = null, ctrl = null, active = -1;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    return '£' + n.toFixed(2);
  }
  function hide() { box.hidden = true; box.innerHTML = ''; active = -1; }
  function render(q, data) {
    var r = (data && data.resources && data.resources.results) || {};
    var prods = r.products || [], cols = r.collections || [], qs = r.queries || [];
    if (!prods.length && !cols.length && !qs.length) {
      box.innerHTML = '<p class="ivh-suggest__h">No quick matches. Press enter to search everything.</p>';
      box.hidden = false; return;
    }
    var h = '';
    var chips = cols.slice(0, 4).map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; })
      .concat(qs.slice(0, 3).map(function (x) { return '<a href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a>'; }));
    if (chips.length) h += '<p class="ivh-suggest__h">Categories &amp; searches</p><div class="ivh-suggest__c">' + chips.join('') + '</div>';
    if (prods.length) {
      h += '<p class="ivh-suggest__h">Products</p>';
      prods.slice(0, 6).forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        h += '<a class="ivh-suggest__p" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="48" height="48">' : '') +
          '<span><span class="ivh-suggest__t">' + esc(p.title) + '</span><br><span class="ivh-suggest__v">' + esc(p.vendor || '') + '</span></span>' +
          '<span class="ivh-suggest__price">' + (p.price ? money(p.price) : '') + '</span></a>';
      });
    }
    h += '<a class="ivh-suggest__all" href="' + form.action + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '”</a>';
    box.innerHTML = h; box.hidden = false; active = -1;
  }
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { hide(); return; }
    timer = setTimeout(function () {
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (d) { if (input.value.trim() === q) render(q, d); })
        .catch(function () {});
    }, 180);
  });
  input.addEventListener('keydown', function (ev) {
    var items = box.querySelectorAll('a');
    if (box.hidden || !items.length) return;
    if (ev.key === 'ArrowDown' || ev.key === 'ArrowUp') {
      ev.preventDefault();
      active = (active + (ev.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items.forEach(function (a, i) { a.classList.toggle('is-active', i === active); });
      items[active].scrollIntoView({ block: 'nearest' });
    } else if (ev.key === 'Enter' && active > -1) {
      ev.preventDefault(); window.location.href = items[active].href;
    } else if (ev.key === 'Escape') { hide(); }
  });
  document.addEventListener('click', function (ev) { if (!form.contains(ev.target)) hide(); });
})();
